import { render } from "./SpecialtyData.vue?vue&type=template&id=3a646234&scoped=true&ts=true"
import script from "./SpecialtyData.vue?vue&type=script&lang=ts"
export * from "./SpecialtyData.vue?vue&type=script&lang=ts"

import "./SpecialtyData.vue?vue&type=style&index=0&id=3a646234&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a646234"]])

export default __exports__